import { Link } from "gatsby";
import React, { useState, useEffect } from "react";
import { Button, Form, Container, Row, Col, Fade } from "react-bootstrap";
import ScrollAnimation from "react-animate-on-scroll";
import Select from "react-dropdown-select";
import { PropertyList } from "./SearchItems";
import "./SearchList.scss";
import {
  isTablet,
  isIPad13,
  isIOS13,
  isMobile,
  isDesktop,
} from "react-device-detect";
import {NoResultProperties} from '../../../queries/common_use_query';
import { ImageModule } from "../../common/Image_Module";
import GetBranch from "../../get-branch";
import Soon from "../../../images/coming-soon.jpg";


const NoResultList = (props) => {
  let fractionValue = 4;

  let [isMoreLoad, setLoadMore] = useState(true);
  let [list, setListItem] = useState([]);

  useEffect(() => {
    if (isIPad13 || isIOS13 || isMobile || isDesktop) {
      setListItem(PropertyList.slice(0, fractionValue));
    } else {
      setLoadMore(false);
      setListItem(PropertyList);
    }
  }, []);

  useEffect(() => {
    if (isIPad13 || isIOS13 || isMobile || isDesktop) {
      if (list.length === PropertyList.length) {
        setLoadMore(false);
      }
    }
  }, [list]);

  const loadMore = () => {
    let currentLength = list.length;
    setListItem(PropertyList.slice(0, currentLength + fractionValue));
  };

  const MaxPrice = [
    { value: "Option", label: "Option" },
    { value: "Option1", label: "Option1" },
    { value: "Option2", label: "Option2" },
    { value: "Option3", label: "Option3" },
  ];
  const[department, setDepartment] = useState('residential');

  useEffect(()=>{
    props.department && setDepartment(props.department);
  },[props.department]);

  const {loading:loading, error:error, data:data} = NoResultProperties(props.status, department);
  return (
    <React.Fragment>
      <div className="search-list-block no-result-list">
        <Container>
          {data && data.properties.length > 0 && data.properties.map((item, index) => {
            var checkptype = props.ptype ==="sales"?'/property-for-sale/' :'/property-to-rent/'
            if(props.department ==="new_developments") {
              checkptype = props.ptype === "sales" ? "/new-home-for-sale/" : "/new-home-to-rent/";
            }
            return (
              <>
                
                  <div className="search-item-box">
                    <Row>
                      <Col md={12} className="d-lg-flex">
                        <div className="search-property-img img-zoom">
                        <Link to={`${checkptype}${item.slug}-${item.id}/`} className="img-zoom">
                          {item.images.length > 0 ?
                            <ImageModule ImageSrc={item.images[0]} ggfx_results={item.ggfx_results} altText={item.display_address} strapi_id={item.id} imagename={"property.images.searchResults"} />
                            :
                            <div className="no-img img-zoom">
                              <img src={Soon} className='mb-0 img-fluid' alt="" />
                            </div>
                          }
                          </Link>
                          <span className="property-tag">
                            {item.status}
                          </span>
                        </div>
                        <div className="search-property-details">
                          <button type="button" className="like-btn d-none">
                            <i className="icon-heart-outline"></i>
                          </button>
                          <h2>
                          <Link to={`${checkptype}${item.slug}-${item.id}/`}>{item.display_address} </Link>
                          </h2>
                          <span className="search-property-text">
                            {item.title}
                          </span>
                          <span className="property-price">
                          £{item.price.toLocaleString()}{" "}{props.ptype === "lettings"?"pcm":""}
                          </span>
                          <div className="property-description">
                            <p>{item.description.slice(0,200)}</p>
                          </div>
                         
                          <GetBranch officecrm={item.office_crm_id} searchtype={item.search_type} />

                          <div className="btn-view">
                          <Link to={`${checkptype}${item.slug}-${item.id}/`} className="btn">
                            View Details
                            </Link>
                            <Link to={`/book-a-viewing?pid=${item.id}`} className="book-text"><i className="icon-calendar"></i> Book a viewing</Link>

                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                
                {index == 1 ? (
                  <Row>
                    <Col md="12">
                      <div className="appraisal-bar">
                        <div className="left-block">
                          <h2>How much is your property worth?</h2>
                          <p>
                            Book a free valuation appointment with one of our
                            experts.
                          </p>
                        </div>
                        <div className="right-block">
                          <Link to="/property-valuation" className="btn">
                            Book your market appraisal
                          </Link>
                        </div>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  ""
                )}
              </>
            );
          })}

        </Container>
      </div>
    </React.Fragment>
  );
};

export default NoResultList;
